// Estructura jerárquica de especialidades y submódulos
// Sin modificar las especialidades base existentes

export const specialtyStructure = {
  "Medicina Interna": {
    hasSubmodules: true,
    submodules: [
      "Cardiología",
      "Dermatología",
      "Endocrinología",
      "Gastroenterología",
      "Hematología",
      "Infectología",
      "Medicina Interna (general)",
      "Nefrología",
      "Neumología",
      "Neurología",
      "Oncología",
      "Reumatología"
    ]
  },
  "Cirugía": {
    hasSubmodules: true,
    submodules: [
      "Angiología",
      "Cirugía General",
      "Cirugía Maxilofacial",
      "Cirugía Plástica",
      "Neurocirugía",
      "Oftalmología",
      "Otorrinolaringología",
      "Trasplantes",
      "Traumatología y Ortopedia",
      "Urología"
    ]
  },
  "Ginecología y Obstetricia": {
    hasSubmodules: false,
    submodules: []
  },
  "Pediatría": {
    hasSubmodules: false,
    submodules: []
  },
  "Otros": {
    hasSubmodules: true,
    submodules: [
      "Alergia e Inmunología",
      "Analgesia y Anestesia",
      "Enfermedades Lisosomales",
      "Genética",
      "Geriatría",
      "Medicina Familiar",
      "Medicina Física y Rehabilitación",
      "Nutriología",
      "Psiquiatría",
      "Urgencias Médico-Quirúrgicas"
    ]
  }
};

// Especialidades base (mantener compatibilidad)
export const baseSpecialties = [
  "Medicina Interna",
  "Cirugía",
  "Ginecología y Obstetricia",
  "Pediatría",
  "Otros"
];

// Función para obtener todos los submódulos de una especialidad
export const getSubmodules = (specialty) => {
  return specialtyStructure[specialty]?.submodules || [];
};

// Función para verificar si una especialidad tiene submódulos
export const hasSubmodules = (specialty) => {
  return specialtyStructure[specialty]?.hasSubmodules || false;
};

// Función para obtener lista plana de todas las opciones
export const getAllSpecialtyOptions = () => {
  const options = [];
  baseSpecialties.forEach(specialty => {
    if (hasSubmodules(specialty)) {
      getSubmodules(specialty).forEach(sub => {
        options.push(`${specialty} - ${sub}`);
      });
    } else {
      options.push(specialty);
    }
  });
  return options;
};
